import * as React from 'react';
import * as styles from './styles.css';

export const ChangeAnswerDesktop: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <div className={styles['change-answer']} onClick={onClick}>
      Изменить ответ
    </div>
  );
};
